import * as tslib_1 from "tslib";
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { updateUserConfiguration } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().ViewStateConfiguration; },
})(action('saveAttachmentPreferencesOption')(function saveAttachmentPreferencesOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.AttachOrShareLocalFiles = getFallbackValueIfNull(optionState.fromComputer, userOptions.AttachOrShareLocalFiles);
                    userOptions.AttachOrShareCloudFiles = getFallbackValueIfNull(optionState.fromOneDrive, userOptions.AttachOrShareCloudFiles);
                    return [4 /*yield*/, updateUserConfiguration([
                            {
                                propertyName: 'AttachOrShareLocalFiles',
                                propertyType: 'Integer32',
                                propertyValue: "" + userOptions.AttachOrShareLocalFiles,
                            },
                            {
                                propertyName: 'AttachOrShareCloudFiles',
                                propertyType: 'Integer32',
                                propertyValue: "" + userOptions.AttachOrShareCloudFiles,
                            },
                        ], 'OWA.ViewStateConfiguration')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveAttachmentPreferencesOption.js.map